// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__wmHEv","icon":"style_icon__1Zasi","title":"style_title__3sNJl"};